import React, { useState } from 'react';
import RangePicker from '@/pages/home/components/RangePicker';
import moment from 'moment';
const defaultValue = {
  '1day': [moment(), moment()],
  '3days': [moment().subtract(2, 'day'), moment()],
  '7days': [moment().subtract(6, 'day'), moment()],
  '30days': [moment().subtract(29, 'day'), moment()],
  date: [moment(), moment()],
  week: [moment().startOf('week'), moment().endOf('week')],
  month: [moment(), moment()],
  hour: [moment(), moment()]
}

const extraShortcut = {
  'date': [
    {
      name: 'Last 7 Days',
      nameCN: '最近7天',
      onClick: () => {
        return [moment().subtract(7, 'day'), moment().subtract(1, 'day')]
      }
    },
    {
      name: 'Last 30 Days',
      nameCN: '最近30天',
      onClick: () => {
        return [moment().subtract(30, 'day'), moment().subtract(1, 'day')]
      }
    },
    {
      name: 'Last 90 Days',
      nameCN: '最近90天',
      onClick: () => {
        return [moment().subtract(90, 'day'), moment().subtract(1, 'day')]
      }
    },
    {
      name: 'Last 180 Days',
      nameCN: '最近180天',
      onClick: () => {
        return [moment().subtract(180, 'day'), moment().subtract(1, 'day')]
      }
    },
    {
      name: 'Last 365 Days',
      nameCN: '最近365天',
      onClick: () => {
        return [moment().subtract(365, 'day'), moment().subtract(1, 'day')]
      }
    },
    {
      name: 'Year to Date',
      nameCN: '今年',
      onClick: () => {
        return [moment().startOf('year'), moment()]
      }
    },
    {
      name: 'Last 7 Days',
      nameCN: '最近7天',
      onClick: () => {
        return [moment().subtract(7, 'day'), moment().subtract(1, 'day')]
      }
    },
    {
      name: 'Last 30 Days',
      nameCN: '最近30天',
      onClick: () => {
        return [moment().subtract(30, 'day'), moment().subtract(1, 'day')]
      }
    },
    {
      name: 'Last 90 Days',
      nameCN: '最近90天',
      onClick: () => {
        return [moment().subtract(90, 'day'), moment().subtract(1, 'day')]
      }
    },
    {
      name: 'Last 180 Days',
      nameCN: '最近180天',
      onClick: () => {
        return [moment().subtract(180, 'day'), moment().subtract(1, 'day')]
      }
    },
    {
      name: 'Last 365 Days',
      nameCN: '最近365天',
      onClick: () => {
        return [moment().subtract(365, 'day'), moment().subtract(1, 'day')]
      }
    },
    {
      name: 'Year to Date',
      nameCN: '今年',
      onClick: () => {
        return [moment().startOf('year'), moment()]
      }
    },
  ]
}

export default (props: any) => {

  const [dateInfo, setDateInfo] = useState({
    type: 'date',
    value: [null, null]
  })

  return (
    <div style={{padding: "40px 120px"}}>
      <RangePicker
        showShortcut={true}
        extraShortcut={extraShortcut}
        showSelectType={true}
        type={dateInfo.type}
        value={dateInfo.value}
        defaultValue={defaultValue}
        typeList={['hour', 'year', 'date', '1day', '3days', '7days', '30days']}
        startOfWeek={0}
        language="cn"
        onChange={(value, type) =>{
          setDateInfo({
            value,
            type
          });
          // console.log(
          //   value[0]?.format("YYYY/MM/DD"),
          //   value[1]?.format("YYYY/MM/DD")
          // )
        }}
      />
    </div>
  );
};
